/**
 * Created by jinbq on 2017/4/10.
 */
import merge from './merge'
export var _wx
function cb(growio, item) {
    var type = 'friends'
    _vds.push(['setPageGroup', growio['page']])
    _vds.push(['setPS1', growio['id']])
    if (item == 'MenuShareTimeline') {
        type = 'timeline'
    }

    _vds.push(['setPS2', type])
    let timer = null
    let count = 0
    timer = setInterval(() => {
        if ('trackPV' in _vds) {
            clearInterval(timer)
            _vds.trackPV()
        } else {
            if (count++ > 1000) {
                clearInterval(timer)
            }
        }
    }, 100)
}
export default function (__wx) {
    _wx = __wx
    function config(config) {
        _wx.config(merge({
            jsApiList: [
                'onMenuShareTimeline',
                'onMenuShareAppMessage',
                'getLocation'
            ]
        }, config))
        return this
    }

    function ready(list = [
        'MenuShareTimeline', 'MenuShareAppMessage'
    ], config, growio = {
        page: '',
        id: ''
    }) {
        _wx.ready(() => {
            list.forEach((item) => {

                _wx['on' + item](merge({
                    title: document.querySelector('meta[name="shareTitle"]').getAttribute('content'),
                    desc: document.querySelector('meta[name="shareDesc"]').getAttribute('content'),
                    imgUrl: document.querySelector('meta[name="shareLogo"]').getAttribute('content'),
                    success: function () {
                        growio['page'] && cb(growio, item)
                    }
                }, config))
            })
        })

        return this
    }

    function error(cb) {
        _wx.error(function (res) {
            if (cb) {
                cb()
            }
            return this
        })
    }

    return {
        config, ready, error
    }
}



// WEBPACK FOOTER //
// ./src/utils/wx.js